export const BIRTHING_ROOT_LINK_ID = "birthing";

export const BIRTHING_DATE_TIME_LINK_ID = "birthingDateTime";
export const BIRTHING_DATE_LINK_ID = "birthingDate";
export const BIRTHING_TIME_LINK_ID = "birthingTime";

export const BIRTHING_CROWN_DATE_TIME_LINK_ID = "birthingCrownDateTime";
export const BIRTHING_HEAD_DATE_TIME_LINK_ID = "birthingHeadDateTime";
export const BIRTHING_BODY_DATE_TIME_LINK_ID = "birthingBodyDateTime";

export const BIRTHING_TYPE_LINK_ID = "birthingType";
export const BIRTHING_POSITION_LINK_ID = "birthingPosition";

export const BIRTHING_IN_WATER_LINK_ID = "birthingInWater";
export const BIRTHING_IN_WATER_OTHER_LINK_ID = "birthingInWaterOther";

export const BIRTHING_FETAL_PRESENTATION_LINK_ID = "birthingFetalPresentation";

export const BIRTHING_DELIVERY_METHOD_LINK_ID = "birthingDeliveryMethod";
export const BIRTHING_DELIVERY_METHOD_OTHER_LINK_ID = "birthingDeliveryMethodOther";

export const BIRTHING_NOTES_LINK_ID = "birthingNotes";
export const BIRTHING_SIGNATURE_INITIALS_LINK_ID = "birthingSignatureInitials";

export const BIRTHING_QUESTIONNAIRE_NAME = "birthing";
